import axios from "axios";
import config from '../config';
import { getDoctorToken } from '../utils';


const getTestimonialApi = async(params) => {
    const response = await axios({
        url: `${config.api.base_url}testimonial/list`,
        method: "get",
        params: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getDoctorToken()}`
          },
    });
console.log(response)
    return response;
}

export default getTestimonialApi;